import React from 'react';

import type { FacebookPostComponentsProps } from './types';

export function Header(_props: FacebookPostComponentsProps): React.JSX.Element {
	return <div>Facebook Post Header</div>;
}
